import { useId } from 'react';
import { Button } from '../button';
import type { ConfirmProps } from './types';
import styles from './Confirm.module.css';

export function Confirm({
    open,
    title,
    message,
    cancelLabel = 'NO',
    confirmLabel = 'YES',
    onCancel,
    onConfirm,
}: ConfirmProps) {
    const titleId = useId();
    const messageId = useId();

    if (!open) {
        return null;
    }

    return (
        <div className={styles.overlay} role="presentation">
            <div
                className={styles.dialog}
                role="alertdialog"
                aria-modal="true"
                aria-labelledby={titleId}
                aria-describedby={messageId}
            >
                <h2 id={titleId} className={styles.title}>
                    {title}
                </h2>
                <p id={messageId} className={styles.message}>
                    {message}
                </p>
                <div className={styles.actions}>
                    <Button type="button" variant="secondary" onClick={onCancel}>
                        {cancelLabel}
                    </Button>
                    <Button type="button" variant="secondary" color="purple" onClick={onConfirm}>
                        {confirmLabel}
                    </Button>
                </div>
            </div>
        </div>
    );
}
